import { PropsWithChildren, createContext, useState } from "react";
import { Bin } from "src/models/Bin";
import { Ica } from "src/models/Ica";
import { Country } from "src/models/Country";
import { Program } from "src/models/Program";
import { Developer } from "src/models/Developer";
import { Portfolio } from "src/models/Portfolio";

export type ContactContextType = {
  developers: Developer[];
  setDevelopers: React.Dispatch<React.SetStateAction<Developer[]>>;
  programs: Program[];
  setPrograms: React.Dispatch<React.SetStateAction<Program[]>>;
  icas: Ica[];
  setIcas: React.Dispatch<React.SetStateAction<Ica[]>>;
  bins: Bin[];
  setBins: React.Dispatch<React.SetStateAction<Bin[]>>;
  countries: Country[];
  setCountries: React.Dispatch<React.SetStateAction<Country[]>>;
  bankIds: string;
  setBankIds: React.Dispatch<React.SetStateAction<string>>;
  portfolios: Portfolio[];
  setPortfolios: React.Dispatch<React.SetStateAction<Portfolio[]>>;
};

const ContactContext = createContext({} as ContactContextType);

export const ContactProvider = ({ children }: PropsWithChildren) => {
  const [developers, setDevelopers] = useState<Developer[]>([]);
  const [programs, setPrograms] = useState<Program[]>([]);
  const [icas, setIcas] = useState<Ica[]>([]);
  const [bins, setBins] = useState<Bin[]>([]);
  const [countries, setCountries] = useState<Country[]>([]);
  const [bankIds, setBankIds] = useState("");
  const [portfolios, setPortfolios] = useState<Portfolio[]>([]);

  return (
    <ContactContext.Provider
      value={{
        developers,
        setDevelopers,
        programs,
        setPrograms,
        icas,
        setIcas,
        bins,
        setBins,
        bankIds,
        setBankIds,
        countries,
        setCountries,
        portfolios,
        setPortfolios
      }}
    >
      {children}
    </ContactContext.Provider>
  );
};

export default ContactContext;
